var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { canApproveHours } from '../../../../backend/utils/shiftStateUtils';
import { useAddShiftForVolunteer } from '../../../../ui/features/shift-details/hooks/useAddShiftForVolunteer';
import { approveHoursDialog } from '../../../../ui/features/shift-roster-table/utils/approveHoursDialog';
import { useShiftParticipantActions } from '../../../../ui/features/shift/hooks/useShiftParticipantActions';
import { useShiftVolunteerManagementWizardSteps } from '../../../../ui/features/volunteers-wizard-dialog/hooks/useShiftVolunteerManagementWizardSteps';
import { useMissionsTranslation, useShiftParticipantStorage } from '../../../../ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import SendIcon from '@mui/icons-material/Send';
import React from 'react';
const defaultShiftsFilter = [{ column: 'stopTime', op: '<', value: Date.now() }];
export function useParticipantShiftsTableActions({ onSendMessageToVolunteers, fetchReload, selected, shifts, missionId, participantId, participantFullName, }) {
    const { t } = useMissionsTranslation();
    const shiftParticipantStorage = useShiftParticipantStorage();
    const { handleApproveHours } = useShiftParticipantActions();
    const { selectPositionStep, selectShiftStep, selectMissionShiftStep } = useShiftVolunteerManagementWizardSteps();
    const { handleAddShift } = useAddShiftForVolunteer({
        steps: [
            missionId
                ? selectShiftStep({
                    additionalShiftFilter: [
                        ...defaultShiftsFilter,
                        {
                            column: 'missionId',
                            op: '=',
                            value: missionId,
                        },
                    ],
                })
                : selectMissionShiftStep({ additionalShiftFilters: defaultShiftsFilter }),
            selectPositionStep(),
        ],
        participantId,
        participantFullName,
        onAfterSubmit: fetchReload,
    });
    const shiftsSelectedInCurrentPage = React.useMemo(() => shifts.filter((s) => selected.includes(s.id)), [selected, shifts]);
    const hasSelectedIdsInOtherPages = shiftsSelectedInCurrentPage.length < selected.length;
    const allowApproveHours = hasSelectedIdsInOtherPages || // cannot check status for other pages - allow
        shiftsSelectedInCurrentPage.some(canApproveHours);
    const getSelectedRows = () => __awaiter(this, void 0, void 0, function* () {
        return (yield shiftParticipantStorage.list({
            filter: [
                {
                    op: 'in',
                    id: selected,
                },
            ],
        })).rows;
    });
    const actions = [
        ...(onSendMessageToVolunteers
            ? [
                {
                    icon: React.createElement(SendIcon, null),
                    label: t('missions.missionDetails.sendMessage'),
                    disabled: !shifts,
                    onClick: () => { var _a, _b, _c; return onSendMessageToVolunteers([(_c = (_b = (_a = shifts === null || shifts === void 0 ? void 0 : shifts[0]) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.participantId) !== null && _c !== void 0 ? _c : '']); },
                    'data-test': 'send-message-button',
                },
            ]
            : []),
        {
            icon: React.createElement(CheckIcon, null),
            label: t('shifts.adminTimeTracking.approveHours'),
            disabled: !allowApproveHours,
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                return approveHoursDialog({
                    rows: yield getSelectedRows(),
                    handleApproveHours,
                    t,
                    fetchReload: () => __awaiter(this, void 0, void 0, function* () {
                        return fetchReload();
                    }),
                });
            }),
            'data-test': 'approve-hours-button',
        },
        {
            icon: React.createElement(AddIcon, null),
            label: t('shifts.addShift'),
            onClick: handleAddShift,
            'data-test': 'add-shift-button',
        },
    ];
    return actions;
}
